export { default } from './es/icons/ExcleTwoTone';